var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.value >= 0) && (_vm.value <= 1))?_c('v-chip',{attrs:{"small":"","color":_vm.color,"text-color":"white"}},[_vm._v(" "+_vm._s(_vm.valueFormatted)+"% ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }